import React from "react";
import { useState, useEffect } from "react";
import { GrLocation } from "react-icons/gr";
import { useDispatch } from "react-redux";
import { setLocation } from "../../redux/posts/posts.action";
import { getGoogleLocation,  } from "../../utils/utils";
import GooglePlace from "../Map/GoglePlaces";

function SelectLocation({ setCurrentLocation, next, close, theme }) {
  const [address, setAddress] = useState("");
  const [, setDisabled] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const { lat, lng } = await getGoogleLocation();
        setCurrentLocation({
          latitude: lat,
          longitude: lng,
        });
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };
  
    fetchLocation();
    // eslint-disable-next-line
  }, []);

  const handleLocationChange = (locations, item) => {
    if (locations && item) {
      setDisabled(false);
      dispatch(setLocation(item));
      setCurrentLocation(locations);
      setAddress(item);
      if (close) {
        close();
      } else {
        next(60);
      }
    } else {
      setDisabled(true);
    }
  };
  return (
    <div className="w-full h-[340px] overflow-y-scroll relative">
      <GooglePlace propsValue={handleLocationChange} />

      {address && (
        <div>
          <h4 className="text-[14px] my-2 font-[500] text-[#1C2024]">
            Selected
          </h4>
          <div className="flex items-center gap-[8px]">
            <GrLocation
              className={` ${
                theme ? "bg-[red] " : "bg-[#02023414] "
              } rounded-[50%] w-[44px] h-[44px] text-[#1c2024] p-3`}
            />
            <div className="">
              <h4 className="text-black text-[14px] font-[510px]">{address}</h4>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SelectLocation;
